import React, { useEffect, useState, Fragment } from 'react'
import { getOrdersDeliveryRealTime } from '../firebase/obj/order'
import { getCurrentUser } from '../firebase/obj/user'

export const PendingOrdersWithData = () => {
    const [pendings, setPendings] = useState(0)


    useEffect(() => {
        const currentUser = getCurrentUser()
        return getOrdersDeliveryRealTime(orders => {
            //console.log('pendientes', orders)
            const qty = orders ? orders.length : 0
            setPendings(qty)
        }, ['En reparto'], currentUser.email)
    }, [])

    return (
        <Fragment>
            <div style={{ color: pendings > 0 ? '#5B0808' : 'green', paddingRight: 15, paddingLeft: 5, fontWeight: 'bold' }}>
                {`Pendientes: ${pendings}`}
            </div>
        </Fragment>
    )
}

export default PendingOrdersWithData